import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  params, bool as boolType, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';

const {
  string, shape, func
} = PropTypes;
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';

const SuperSkuMiddleware = ({ itemId, children }) => {
  const storeId = useStoreId();
  const { isServer } = useContext(ExperienceContext);

  const { data: productData } = useDataModel('clientOnlyProduct', {
    variables: {
      itemId,
      storeId
    },
    skip: !itemId,
    ssr: false
  });

  const additionalProps = {};
  const displayConfigurator = !isServer && productData?.product?.identifiers?.productType === 'CONFIGURABLE_BLINDS';

  if (!productData || displayConfigurator) {
    return null;
  }

  return children({ props: additionalProps });
};

SuperSkuMiddleware.propTypes = {
  itemId: string.isRequired,
  children: func.isRequired
};

SuperSkuMiddleware.displayName = 'SuperSkuRules';

SuperSkuMiddleware.dataModel = {
  clientOnlyProduct: params({ itemId: stringType().isRequired() }).shape({
    info: shape({
      dotComColorEligible: boolType()
    })
  })
};

export { SuperSkuMiddleware };